/**
 * 内存中转桥接，用于路由跳转时传递大体积 PDF base64 数据
 * 替代 sessionStorage，避免 quota exceeded 错误
 */
const _store = {}

export function setPdfBridgeData(key, value) {
    _store[key] = value
}

export function getPdfBridgeData(key) {
    return _store[key] || null
}

export function clearPdfBridgeData(key) {
    delete _store[key]
}
